import { useEffect } from 'react';
import { LoadingSpinner } from 'Themes/ScufStyledComponents';
import OSSAgreementContent from './Components/OSSAgreementContent';

export const OSSAgreement = ({ loading = false }) => {
  return loading
    ? (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
      }}>
        <LoadingSpinner />
      </div>
    )
    : <OSSAgreementContent />;
};

export default ({
  getOSSAgreementValidation = () => {},
  loading = false,
}) => {
  useEffect(() => {
    getOSSAgreementValidation();
  }, []);

  return <OSSAgreement loading={loading} />;
};



